import Icon from 'vue-awesome/components/Icon'

Icon.register({
  local_activity_sharp: {
    paths: [
      {
        d: 'M20 12c0-1.1.9-2 2-2V4H2.01v6c1.1 0 1.99.9 1.99 2s-.89 2-2 2v6h20v-6c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z'
      }
    ],
    width: '24',
    height: '24'
  }
})
